(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  const updateCartFreeShippingMessage = (cart) => {
    const container = document.querySelector('#CartDrawer [data-free-shipping-threshold]');
    const message = container?.querySelector('[data-free-shipping-message]');
    if (!container || !message || !cart) return;

    const threshold = Math.round(Number(container.dataset.freeShippingThreshold) || 0);
    const total = Math.round(Number(cart.total_price) || 0);
    const remaining = Math.max(0, threshold - total);

    if (remaining > 0) {
      const amount = theme.Currency.formatMoney(remaining, theme.settings.moneyFormat);
      message.innerHTML = container.dataset.freeShippingRemainingTemplate.replace('__AMOUNT__', amount);
    } else {
      message.innerHTML = container.dataset.freeShippingUnlockedMessage;
    }
  };

  document.addEventListener('cart:updated', (event) => {
    updateCartFreeShippingMessage(event.detail?.cart);
  });

  if (window.theme?.pubsub && theme.pubsub.PUB_SUB_EVENTS?.cartUpdate) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
      updateCartFreeShippingMessage(event?.cart);
    });
  }

  let freeShippingSyncTimer;
  document.addEventListener('change', (event) => {
    if (!event.target.matches('#CartDrawer quantity-input input[name="updates[]"]')) return;

    window.clearTimeout(freeShippingSyncTimer);
    freeShippingSyncTimer = window.setTimeout(async () => {
      try {
        const response = await fetch(`${theme.routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        updateCartFreeShippingMessage(await response.json());
      } catch (error) {
        console.warn('Unable to refresh the free-shipping message.', error);
      }
    }, 650);
  });

  const getGuidedRecommendationVariants = (form) => {
    const data = form.querySelector('[data-guided-cart-recommendation-variants]');
    if (!data) return [];

    try {
      return JSON.parse(data.textContent);
    } catch (error) {
      console.warn('Unable to read recommendation variants.', error);
      return [];
    }
  };

  const getGuidedRecommendationOptions = (form) => {
    const options = [];

    form.querySelectorAll('[data-guided-cart-recommendation-option]').forEach((select) => {
      options[Number(select.dataset.optionPosition) - 1] = select.value;
    });

    form.querySelectorAll('[data-guided-cart-recommendation-swatch].is-selected').forEach((swatch) => {
      options[Number(swatch.dataset.optionPosition) - 1] = swatch.dataset.optionValue;
    });

    return options;
  };

  const updateGuidedRecommendationAvailability = (form, variants, selectedVariant) => {
    form.querySelectorAll('[data-guided-cart-recommendation-option]').forEach((select) => {
      const optionIndex = Number(select.dataset.optionPosition) - 1;

      Array.from(select.options).forEach((option) => {
        const candidateOptions = [...selectedVariant.options];
        candidateOptions[optionIndex] = option.value;
        option.disabled = !variants.some(
          (variant) =>
            variant.available &&
            variant.options.every((value, index) => value === candidateOptions[index])
        );
      });
    });

    form.querySelectorAll('[data-guided-cart-recommendation-swatch]').forEach((swatch) => {
      const optionIndex = Number(swatch.dataset.optionPosition) - 1;
      const candidateOptions = [...selectedVariant.options];
      candidateOptions[optionIndex] = swatch.dataset.optionValue;
      swatch.disabled = !variants.some(
        (variant) =>
          variant.available &&
          variant.options.every((value, index) => value === candidateOptions[index])
      );
    });
  };

  const updateGuidedRecommendationImage = (form, selectedVariant) => {
    const card = form.closest('.horizontal-product');
    const media = card?.querySelector('[data-guided-cart-recommendation-media]');
    const image = media?.querySelector('img');
    if (!image) return;

    const source =
      selectedVariant.featured_media?.preview_image?.src ||
      selectedVariant.featured_image?.src;
    if (!source) return;

    const imageUrl = (width) => {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    };
    const nextSource = imageUrl(360);
    const currentSource = new URL(image.currentSrc || image.src, window.location.origin);
    currentSource.searchParams.delete('width');
    const comparisonSource = new URL(source, window.location.origin);
    comparisonSource.searchParams.delete('width');
    if (currentSource.toString() === comparisonSource.toString()) return;

    image.classList.add('is-switching');
    image.src = nextSource;
    image.srcset = `${imageUrl(180)} 180w, ${nextSource} 360w, ${imageUrl(540)} 540w`;
    image.alt = selectedVariant.featured_media?.alt || selectedVariant.featured_image?.alt || image.alt;
    image.decode().catch(() => {}).finally(() => image.classList.remove('is-switching'));
  };

  const syncGuidedRecommendationForm = (form, changedControl) => {
    const variants = getGuidedRecommendationVariants(form);
    if (!variants.length) return;

    const selectedOptions = getGuidedRecommendationOptions(form);
    let selectedVariant = variants.find(
      (variant) =>
        variant.available &&
        variant.options.every(
          (value, index) => selectedOptions[index] == null || value === selectedOptions[index]
        )
    );

    if (!selectedVariant && changedControl) {
      const changedIndex = Number(changedControl.dataset.optionPosition) - 1;
      const changedValue =
        changedControl.dataset.optionValue == null
          ? changedControl.value
          : changedControl.dataset.optionValue;
      selectedVariant = variants.find(
        (variant) => variant.available && variant.options[changedIndex] === changedValue
      );
    }

    selectedVariant ||= variants.find((variant) => variant.available);

    const variantInput = form.querySelector('[data-guided-cart-recommendation-variant]');
    const addButton = form.querySelector('.guided-cart-recommendation__add');
    if (!selectedVariant) {
      if (variantInput) variantInput.value = '';
      if (addButton) {
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
      }
      return;
    }

    if (variantInput) variantInput.value = selectedVariant.id;
    if (addButton) {
      addButton.disabled = false;
      addButton.removeAttribute('aria-disabled');
    }

    form.querySelectorAll('[data-guided-cart-recommendation-option]').forEach((select) => {
      const optionIndex = Number(select.dataset.optionPosition) - 1;
      select.value = selectedVariant.options[optionIndex];
    });

    form.querySelectorAll('[data-guided-cart-recommendation-swatch]').forEach((swatch) => {
      const optionIndex = Number(swatch.dataset.optionPosition) - 1;
      const selected = swatch.dataset.optionValue === selectedVariant.options[optionIndex];
      swatch.classList.toggle('is-selected', selected);
      swatch.setAttribute('aria-pressed', String(selected));
    });

    const card = form.closest('.horizontal-product');
    const price = card?.querySelector('[data-guided-cart-recommendation-price]');
    if (price) {
      price.textContent = `$${(Number(selectedVariant.price) / 100).toFixed(2)}`;
    }

    updateGuidedRecommendationImage(form, selectedVariant);
    updateGuidedRecommendationAvailability(form, variants, selectedVariant);
  };

  const setGuidedRecommendationCollapsedState = (recommendations, collapsed) => {
    const button = recommendations.querySelector('.guided-cart-recommendation__toggle');
    const content = recommendations.querySelector('product-complementary');
    if (!button) return;

    recommendations.classList.toggle('is-collapsed', collapsed);
    button.setAttribute('aria-expanded', String(!collapsed));
    button.dataset.guidedDisclosureInitialized = 'true';
    if (content) {
      content.toggleAttribute('inert', collapsed);
      content.setAttribute('aria-hidden', String(collapsed));
    }
  };

  const initializeGuidedRecommendationDisclosures = () => {
    document.querySelectorAll('#CartDrawer product-recommendations').forEach((recommendations) => {
      const button = recommendations.querySelector('.guided-cart-recommendation__toggle');
      if (!button || button.dataset.guidedDisclosureInitialized === 'true') return;
      setGuidedRecommendationCollapsedState(recommendations, false);
    });
  };

  const initializeGuidedRecommendationForms = () => {
    document.querySelectorAll('#CartDrawer .guided-cart-recommendation__form').forEach((form) => {
      syncGuidedRecommendationForm(form);
    });
    initializeGuidedRecommendationDisclosures();
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-guided-cart-recommendation-swatch]');
    if (!swatch || swatch.disabled) return;

    const form = swatch.closest('.guided-cart-recommendation__form');
    if (!form) return;

    const optionPosition = swatch.dataset.optionPosition;
    form
      .querySelectorAll(`[data-guided-cart-recommendation-swatch][data-option-position="${optionPosition}"]`)
      .forEach((option) => {
        option.classList.toggle('is-selected', option === swatch);
        option.setAttribute('aria-pressed', String(option === swatch));
      });
    syncGuidedRecommendationForm(form, swatch);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-guided-cart-recommendation-option]');
    if (!select) return;

    const form = select.closest('.guided-cart-recommendation__form');
    if (form) syncGuidedRecommendationForm(form, select);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGuidedRecommendationForms);
  } else {
    initializeGuidedRecommendationForms();
  }

  document.addEventListener('cart:updated', () => {
    window.requestAnimationFrame(initializeGuidedRecommendationForms);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.guided-cart-recommendation__toggle');
    if (!button) return;

    const recommendations = button.closest('product-recommendations');
    if (!recommendations) return;

    setGuidedRecommendationCollapsedState(recommendations, !recommendations.classList.contains('is-collapsed'));
  });

  } catch(e) { console.error(e); }
})();
})();
